<script>
    import HeaderCart from "./HeaderCart";

    export default {
        el: '#header-cart-mobile',

        name: "CartFastMobile",

        extends: HeaderCart,
    }
</script>